var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"md-padding\"\u003E\u003Chelp-box heading=\"Your auction bids\"\u003E\u003Cp\u003EBelow is a list of the bids you have made in active loan auctions and those awaiting acceptance by the borrower.\n\nAt the end of a successful auction, those bids that are \u003Cb\u003Eactive\u003C\u002Fb\u003E or \u003Cb\u003Epartially outbid\u003C\u002Fb\u003E\nwill be marked as \u003Cb\u003Epending\u003C\u002Fb\u003E, before being converted to loan units in an investment.\u003C\u002Fp\u003E\u003Cp\u003EOnce the loan has been successfully issued, you can monitor your investment on the Your loan investments table above.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Cmd-table-container\u003E\u003Ctable md-table md-progress=\"vm.loading\"\u003E\u003Cthead md-head md-order=\"vm.order\"\u003E\u003Ctr md-row\u003E\u003Cth class=\"ref\" md-column md-order-by=\"bid.auction.loanRequest.reference + '.' + bid.id\"\u003ELoan reference\u003C\u002Fth\u003E\u003Cth class=\"created-at\" md-column md-order-by=\"createdAt\"\u003EBid time\u003C\u002Fth\u003E\u003Cth class=\"type\" md-column md-order-by=\"type\"\u003EType\u003C\u002Fth\u003E\u003Cth class=\"status\" md-column md-order-by=\"bidStatus\"\u003EStatus\u003C\u002Fth\u003E\u003Cth class=\"rate\" md-column md-numeric md-order-by=\"minRate * 1.0\"\u003EInvestor rate\u003C\u002Fth\u003E\u003Cth class=\"amount\" md-column md-numeric md-order-by=\"amount * 1.0\"\u003EAmount\u003C\u002Fth\u003E\u003Cth class=\"active-rate\" md-column md-numeric md-order-by=\"activeRate * 1.0\"\u003EActive rate\u003C\u002Fth\u003E\u003Cth class=\"active-amount\" md-column md-numeric md-order-by=\"activeAmount * 1.0\"\u003EActive amount\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody ng-if=\"vm.bids.length &gt; 0\" md-body\u003E\u003Ctr md-row ng-repeat=\"bid in vm.bids | orderBy : vm.order\"\u003E\u003Ctd class=\"ref\" md-cell\u003E\u003Ca ui-sref=\"loanRequestDetails({id: bid.auction.loanRequestId})\"\u003E{{bid.auction.loanRequest.reference + '.' + bid.id}}\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"created-at\" md-cell\u003E{{bid.createdAt | asLocaltime : 'D MMM H:mm'}}\u003C\u002Ftd\u003E\u003Ctd class=\"type\" md-cell\u003E{{bid.type}}\u003C\u002Ftd\u003E\u003Ctd class=\"status\" md-cell\u003E{{bid.bidStatus}}\u003C\u002Ftd\u003E\u003Ctd class=\"rate\" md-cell\u003E{{bid.minRate* 1.0 - bid.auction.investorMarginRate * 1.0 | number : 1}}%\u003C\u002Ftd\u003E\u003Ctd class=\"amount\" md-cell\u003E{{bid.amount | asCurrency}}\u003C\u002Ftd\u003E\u003Ctd class=\"active-rate\" md-cell\u003E{{bid.activeRate | number:1}}%\u003C\u002Ftd\u003E\u003Ctd class=\"active-amount\" md-cell\u003E{{bid.activeAmount | asCurrency}}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003Ctbody class=\"no-entries\" ng-if=\"vm.bids.length == 0\" md-body\u003E\u003Ctr md-row\u003E\u003Ctd md-cell colspan=\"8\"\u003ENo active bids found.\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fmd-table-container\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;